import React from 'react';
import { useEffect, useState } from "react";
import { BsArrowUpCircle } from 'react-icons/bs';

import './ScrollUp.css'

const ScrollUp = () => {

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
          if (window.pageYOffset > 300) {
            setShowButton(true);
          } else {
            setShowButton(false);
          }
        });
      }, []);

      const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // for smoothly scrolling
        });
      };

    return(
        <div className="app__scrollup">
            {showButton && ( <BsArrowUpCircle className="scroll_up" onClick={scrollToTop}/> )}
        </div>

      
    );
}

export default ScrollUp;